module.exports = __webpack_public_path__ + "6d3e28057f70df91fb30c1202e934125.svg";